import Vue from "vue";
import Vuex from "vuex";
import { mapGetters } from 'vuex';

Vue.use(Vuex);

const state = {
  data : {
    "page": null,
    "user_email": null,
    "user_firstname": null,
    "user_lastname": null,
    "site": {
      "name": "TriviaPop",
      "slug": "dev",
      "domain": "dev.triviapop.com",
      "google_analytics_id": "",
      "cdn_url": "",
      "company_name": "andrea",
      "company_address": null,
      "company_address2": null,
      "company_city": null,
      "company_state": null,
      "company_zipcode": null,
      "company_phone": null,
      "company_contact_email": null,
      "is_active": true,
    },
    "trivia": {
      "member": {
        email: null,
        firstname: null,
        lastname: null
      },
      "question": {
        "question": null,
        "type": null,
        "headline_image": null,
        "answer_choices": [],
        "post_url": null,
        "correct_percent": null
      },
      "results": {
        "is_correct": null,
        "correct_answer": null,
        "answer_stats": [{
          "answer": null,
          "percent": null
        }, {
          "answer": null,
          "percent": null
        }, {
          "answer": null,
          "percent": null
        }, {
          "answer": null,
          "percent": null
        }],
        "answer": [],
        "answer_content": {
          "description": null,
          "headline_image": null,
          "headline_title": null
        }
      }
    }
  }
};
const mutations = {
  /**
   * @param state
   * Sets data from TRIVIA_DATA object.
   */
  setData(state) {
    state.data.trivia = (typeof TRIVIA_DATA !== 'undefined') ? TRIVIA_DATA : state.data.trivia;
    state.data.site = (typeof SITE_DATA !== 'undefined') ? SITE_DATA : state.data.site;
    state.data.page = (typeof pageName !== 'undefined') ? pageName : null;
    state.data.user_email = (typeof userEmail !== 'undefined') ? userEmail : null;
    state.data.user_firstname = (typeof userFirstName !== 'undefined') ? userFirstName : null;
    state.data.user_lastname = (typeof userLastName !== 'undefined') ? userLastName : null;
    state.data.userStatus = (typeof userStatus !== 'undefined') ? userStatus : null;
  },
  updateEmail(state, userEmail) {
    state.data.user_email = userEmail || null;
  },
  updateFirstName(state, userFirstName) {
    state.data.user_firstname = userFirstName || null;
  },
  updateLastName(state, userLastName) {
    state.data.user_lastname = userLastName || null;
  }
};
const actions = {
  GET_DATA({ state, commit }) {
    commit('setData');
  }
};

export default new Vuex.Store({
  state,
  mutations,
  actions
});
